import { render, staticRenderFns } from "./addCart.vue?vue&type=template&id=b5894212&"
import script from "./addCart.vue?vue&type=script&lang=js&"
export * from "./addCart.vue?vue&type=script&lang=js&"
import style0 from "./addCart.vue?vue&type=style&index=0&id=b5894212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports